import {Component, OnInit} from '@angular/core';
import {TicketsService} from '../../../../services/tickets.service';
import {Ticket} from '../../../../model/Ticket';
import {FaqCategory} from '../../../../model/FaqCategory';
import {FaqCategoryService} from '../../../../services/faq-category.service';
import {RouterLink} from "@angular/router";
import {CommonModule} from "@angular/common";
import {BadgeComponent} from "../../../common/badge/badge.component";
import {DashBlockComponent} from "../dash-block.component";

@Component({
    selector: 'app-dash-block-tickets',
    templateUrl: './dash-block-tickets.component.html',
    imports: [
        CommonModule,
        RouterLink,
        BadgeComponent,
        DashBlockComponent
    ],
    styleUrls: ['./dash-block-tickets.component.css']
})
export class DashBlockTicketsComponent implements OnInit {

  tickets: Ticket[] = undefined;
  categories: FaqCategory[];
  error = false;

  constructor(private ticketService: TicketsService,
              private faqCategoryService: FaqCategoryService) {
  }

  ngOnInit(): void {
    this.faqCategoryService.getAllCategories().subscribe(cats => {
      this.categories = cats;
    });
    this.ticketService.getTickets(false, '').subscribe(data => {
      this.tickets = data
        .filter(t => !t.state.startsWith('3') && !t.state.startsWith('4'))
        .sort((a, b) => {
          return new Date(b.changed).getTime() - new Date(a.changed).getTime();
        })
        .slice(0, 3);
    }, () => {
      this.error = true;
    });
  }

  getCategoryFromSlug(p: any): FaqCategory {
    if (this.categories === undefined) {
      return undefined;
    }
    return this.categories.find(c => {
      return c.slug.toLowerCase() === p.toLowerCase();
    });
  }

}
